import React from "react"

const DiscountSvg = ({ className }) => {
  return (
    <svg className={className} x="0px" y="0px" viewBox="0 0 512 512" enableBackground="new 0 0 512 512">
      <linearGradient
        id="SVGID_1_"
        gradientUnits="userSpaceOnUse"
        x1="256"
        y1="514"
        x2="256"
        y2="2"
        gradientTransform="matrix(1 0 0 -1 0 514)">
        <stop offset="0" stopColor="#2AF598" />
        <stop offset="1" stopColor="#009EFD" />
      </linearGradient>
      <path
        fill="url(#SVGID_1_)"
        d="M437.02,74.98C388.667,26.629,324.38,0,256,0S123.333,26.629,74.98,74.98
      C26.629,123.333,0,187.62,0,256s26.629,132.667,74.98,181.02C123.333,485.371,187.62,512,256,512s132.667-26.629,181.02-74.98
      C485.371,388.667,512,324.38,512,256S485.371,123.333,437.02,74.98z M256,472c-119.103,0-216-96.897-216-216S136.897,40,256,40
      s216,96.897,216,216S375.103,472,256,472z M233,186c0-33.084-26.916-60-60-60s-60,26.916-60,60s26.916,60,60,60S233,219.084,233,186
      z M153,186c0-11.028,8.972-20,20-20s20,8.972,20,20s-8.972,20-20,20S153,197.028,153,186z M338,266c-33.084,0-60,26.916-60,60
      s26.916,60,60,60s60-26.916,60-60S371.084,266,338,266z M338,346c-11.028,0-20-8.972-20-20s8.972-20,20-20s20,8.972,20,20
      S349.028,346,338,346z M343.599,136L213.87,376h-45.469L298.13,136H343.599z"
      />
    </svg>
  )
}

export default DiscountSvg
